import { useParams } from "react-router";
import { z } from "zod";

export const useParsedParams = <T extends z.ZodType>(schema: T, errorMessage?: string) => {
  const params = useParams();
  return parseParams(params, schema, errorMessage);
};

export const parseParams = <T extends z.ZodType>(params: unknown, schema: T, errorMessage?: string) => {
  const parsedParams = schema.safeParse(params);
  if (!parsedParams.success) {
    throw new Error(
      errorMessage ?? `Param parsing failed: ${parsedParams.error.message}. Params passed: ${JSON.stringify(params)}`
    );
  }
  return parsedParams.data;
};
